import type { IMedia } from "src/model/unityObject";
import getMediaMetadata from "./getMediaMetadata";

const hasMediaBeenGeneratedByAi = (media: IMedia): boolean => {
  const metadata = getMediaMetadata(media);
  if (!metadata || typeof metadata !== "object") {
    return false;
  }
  const hasBeenReplaced =
    Array.isArray(metadata.replaceHistory) && metadata.replaceHistory.length > 0;
  return Boolean(metadata.initialPrompt) && !hasBeenReplaced;
};

export default hasMediaBeenGeneratedByAi;
